import * as React from 'react';

import Box from '@mui/material/Box';
import AppPage from '@/ui/AppPage/AppPage';
import UsersTable from './UsersTable';

import { Permissions } from '@/lib/permissions';

const UsersPage = () => (
  <AppPage needPermission={[Permissions.Administration, Permissions.AdministrationOrgUsers]}>
    <Box m={0} style={{ height: '100%' }}>
      <UsersTable />
    </Box>
  </AppPage>
);

export default UsersPage;
